// src/app/core/guards/server-error.guard.ts
import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ServerErrorService } from '../services/server-error.service';

@Injectable({
  providedIn: 'root'
})
export class ServerErrorGuard implements CanActivate {
  constructor(
    private router: Router,
    private serverErrorService: ServerErrorService
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {

    const hasServerError = this.serverErrorService.hasServerError();

    if (hasServerError) {
      // Block ALL navigation - redirect to error page
      console.log('Server error active - blocking navigation to:', state.url);
      this.router.navigate(['/server-error']);
      return false;
    }

    return true;
  }
}